export default __webpack_public_path__ + "static/media/nutrionist.690f2836.png";